import React, { useContext } from 'react'
import { FaCoins, FaShoppingCart, FaUser } from 'react-icons/fa'
import { MdLogout, MdShoppingCartCheckout } from 'react-icons/md'
import { Link } from 'react-router'
import AuthContext from '../../Store/AuthContext'
import styles from './UserProfileNavigator.module.css'

const UserProfileNavigator = () => {
    const authCtx = useContext(AuthContext);
    const loginData = JSON.parse(authCtx.loginData);

    return (
        <div className={styles.navWrapper}>
            <div className={styles.navContainer}>
                <Link to={`/user/profile`} className={styles.eachNavOption}>
                    <FaUser size={18} />
                    <div className={styles.navTitle}>
                        Profile
                    </div>
                </Link>
                <Link to={`/user/orders`} className={styles.eachNavOption}>
                    <FaShoppingCart size={18} />
                    <div className={styles.navTitle}>
                        Orders
                    </div>
                </Link>
                <div className={styles.eachSectionWrapper}>
                    <div>
                        <div className={styles.sectionTitle}>
                            Points Zone
                        </div>
                    </div>
                    <Link to={`/points/transactions`} className={styles.eachNavOption}>
                        <FaCoins size={18} />
                        <div className={styles.navTitle}>
                            Txn(s)
                        </div>
                    </Link>
                    <Link to={`/points/orders`} className={styles.eachNavOption}>
                        <MdShoppingCartCheckout size={18} />
                        <div className={styles.navTitle}>
                            Redemption
                        </div>
                    </Link>
                </div>
            </div>

            <div className={styles.logoutBtn} onClick={() => authCtx.logout()}>
                <MdLogout size={18} />
                <div className={styles.navTitle}>
                    Logout
                </div>
            </div>

        </div>
    )
}

export default UserProfileNavigator